const ErrorStatusEnum = {
	ERROR: 1,
	WARNING: 2,
	ALERT: 3,
};

const MaxFileSizeEnum = {
	QUESTION: 1024 * 1024 * 15,
	KATS_JUST: 1024 * 1024 * 81,
	SOM_JUST: 1024 * 1024 * 81,
	VOR_JUST: 1024 * 1024 * 81,
};

const XmlResourceTypeEnum = {
	ITEM: 1,
	ITEM_RESOURCE: 2,
	COST_RESOURCE: 3,
	COST_RESOURCE_INTERNAL: 4,
};

const CharTypeEnum = {
	NUMBER: "Number",
	POSITIVE_INT: "PositiveInt",
	ENUM: "Enum",
	STRING: "Str",
	BOOLEAN: "Bool",
	DATE: "Date",
};

const RemoteUrlEnum = {
	LIFE_MAP: "https://smetafree.platformaexpert.ru/life_infrast_map",
};

const LocalStorageVarEnum = {
	ESTM_VIEWER_ADV_SEACH_SHOW: "show_adv_search_on_estimate_viewer",
	ESTM_VIEWER_ADV_SEACH_PARAM: "adv_search_params_on_estimate_viewer",
};

export const CharPriorTypeEnum = {
	GENERAL: "General",
	MAIN: "Main",
	OTHER: "Other",
	SERVICE: "Service",
};

export const SomDbViewModesEnum = {
	FLAT: "flat",
	NESTED: "nested",
	MULTI_NESTED: "multi_nested",
};

export const ExpertEstmStatusEnum = {
	UPLOAD: 1,
	VALID: 2,
	NOT_VALID: 3,
};

export const ExpertEstmStatusTitleEnum = {
	UPLOAD: "Загружено",
	VALID: "Согласовано",
	NOT_VALID: "Вернули на доработку",
};

export const ErrorEnum = {
	KATS_JUST_PRICE: 196,
	KATS_JUST_NAME: 197,
};

export { CharTypeEnum, ErrorStatusEnum, LocalStorageVarEnum, MaxFileSizeEnum, RemoteUrlEnum, XmlResourceTypeEnum };
